<template>
    <Row type="none" />
</template>

<script>
    import Row from "../../components/html/Row";
    import localStorageLang from "@/store/local/localStorageLang";
    export default {
        name: "Logout",
        components: {Row},
        methods: {
            setCookie(name, value, days) {
                let expires = ''

                if (days) {
                    const date = new Date();
                    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                    expires = "; expires=" + date.toUTCString();
                }

                let domain = ''

                if (process.env.NODE_ENV === 'production') {
                    domain = 'domain=.boshqar.com'
                }

                document.cookie = name + "=" + (value || "") + expires + `; path=/; ${domain}`;
            },
            goToPromoApp() {
                switch (process.env.VUE_APP_BRANCH) {
                    case 'master':
                        window.location.href = `${process.env.VUE_APP_PROMO_MASTER_URL}/${localStorageLang.get()}`
                        break
                    case 'dev':
                        window.location.href = `${process.env.VUE_APP_PROMO_DEV_URL}/${localStorageLang.get()}`
                        break
                    case 'local':
                        window.location.href = `${process.env.VUE_APP_PROMO_LOCAL_URL}/${localStorageLang.get()}`
                        break
                }
            }
        },
        mounted() {
            this.$store.dispatch('clearTokens')
            this.flashInfo(window.i18n.t('login.bye'));
            this.setCookie('access', '', 7)
            this.setCookie('refresh', '', 7)
            this.$bvModal.hide('user-info')
            this.$i18nHelper.toUrl('/login')
            window.location.reload()
            // this.goToPromoApp()
        }
    }
</script>

<style scoped>

</style>